module.exports = __webpack_public_path__ + "img/logo.ba918a99.svg";